export default {
    "software_version": "v1.0.1",
    "apiUrl": "https://api.elbet.com/index.php/",
    "defaultLanguage": {
        "name": "serbian",
        "short": "rs"
    },
    "languages": [
        {
            "name": "serbian",
            "short": "rs"
        }, 
        {
            "name": "english",
            "short": "en"
        }
    ],
    "gameIds" : {
        "luckyBalls": 1,
        "luckyGreek": 8,
        "dogRacing": 2,
        "bingo49": 16
    }
}
